// @flow
import styled from 'styled-components';

export const Container: any = styled.div`
  padding-top: 64px;
`;

export default Container;
